import { render, staticRenderFns } from "./EmptyData.vue?vue&type=template&id=3cdba6e6&"
import script from "./EmptyData.vue?vue&type=script&lang=ts&"
export * from "./EmptyData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports